'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fTitle$002ejs from "@ui5/webcomponents/dist/Title.js";
import * as $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent from "./be.doeraene.webcomponents.-Web-Component.js";
import * as $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dTitle$002dLevel$0024 from "./be.doeraene.webcomponents.ui5.configkeys.-Title-Level$.js";
import * as $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dTitle$002dLevel$0024$002dH3$0024 from "./be.doeraene.webcomponents.ui5.configkeys.-Title-Level$-H3$.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024 from "./com.raquo.laminar.tags.-Custom-Html-Tag$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_Title$() {
  this.Dn = null;
  this.Dl = null;
  this.Dm = false;
  $n_Lbe_doeraene_webcomponents_ui5_Title$ = this;
  $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__$init$__V(this);
  $i_$0040ui5$002fwebcomponents$002fdist$002fTitle$002ejs.default;
  this.Dn = new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_tags_CustomHtmlTag("ui5-title", $j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$().eO(), ($j_com$002eraquo$002elaminar$002etags$002e$002dCustom$002dHtml$002dTag$0024.$m_Lcom_raquo_laminar_tags_CustomHtmlTag$(), (void 0)));
}
export { $c_Lbe_doeraene_webcomponents_ui5_Title$ as $c_Lbe_doeraene_webcomponents_ui5_Title$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_Title$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_Title$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_Title$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_Title$ as $h_Lbe_doeraene_webcomponents_ui5_Title$ };
$h_Lbe_doeraene_webcomponents_ui5_Title$.prototype = $p;
$p.fP = (function(x$0) {
});
$p.ec = (function() {
  return this.Dn;
});
$p.XF = (function() {
  if ((!this.Dm)) {
    this.Dl = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "size", $j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dTitle$002dLevel$0024.$m_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$().wV()));
    this.Dm = true;
  }
  return this.Dl;
});
$p.Pd = (function(mods) {
  return $j_be$002edoeraene$002ewebcomponents$002e$002dWeb$002dComponent.$f_Lbe_doeraene_webcomponents_WebComponent__apply__sci_Seq__Lcom_raquo_laminar_nodes_ReactiveHtmlElement(this, mods.da(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$3) => _$3.XF().w($j_be$002edoeraene$002ewebcomponents$002eui5$002econfigkeys$002e$002dTitle$002dLevel$0024$002dH3$0024.$m_Lbe_doeraene_webcomponents_ui5_configkeys_TitleLevel$H3$())))));
});
var $d_Lbe_doeraene_webcomponents_ui5_Title$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_Title$, "be.doeraene.webcomponents.ui5.Title$", ({
  gr: 1,
  ar: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_Title$ as $d_Lbe_doeraene_webcomponents_ui5_Title$ };
var $n_Lbe_doeraene_webcomponents_ui5_Title$;
function $m_Lbe_doeraene_webcomponents_ui5_Title$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_Title$)) {
    $n_Lbe_doeraene_webcomponents_ui5_Title$ = new $c_Lbe_doeraene_webcomponents_ui5_Title$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_Title$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_Title$ as $m_Lbe_doeraene_webcomponents_ui5_Title$ };
